<div class="appearance tool-box">
    <h5 class="title">
        {{ 'mimic-drawing.appearance' | translate }}
    </h5>
    <div class="option-container" *ngIf="!connectorType">
        <div class="title-container">
            <h6 class="sub-title">
                {{ 'mimic-drawing.layer-opacity' | translate }}
            </h6>
            <mat-icon
                class="icon-pointer"
                (click)="opacityIconClick()"
                [svgIcon]="shouldHideOpacity ? 'hidden' : 'visible'"></mat-icon>
        </div>
        <div class="appearance-input-container">
            <app-editor-input-text
                name="opacity"
                [label]="'mimic.design.opacity.label' | translate"
                [value]="opacity"
                [type]="opacity == MIXED_STRING ? 'text' : 'number'"
                unit="%"
                [shouldEmitOnBlur]="true"
                (onInputChange)="handleOpacityChange($event)"
                (onInputKeyDown)="validSpacingKeyDown($event)">
            </app-editor-input-text>
        </div>
    </div>
    <div class="option-container" *ngIf="!isFillHidden">
        <div class="title-container">
            <h6 class="sub-title contain-icon">
                {{ 'mimic-drawing.bgcolor-fill' | translate }}
                <mat-icon
                    *ngIf="hasFillAttribute"
                    class="icon-pointer"
                    (click)="fillIconClick()"
                    [svgIcon]="fillHidden ? 'hidden' : 'visible'"></mat-icon>
            </h6>
            <mat-icon class="icon-pointer" *ngIf="!hasFillAttribute" (click)="addFillColor()" svgIcon="plus"></mat-icon>
        </div>
        <div class="fill-input-container" [class.stroke-hidden]="hideStrokeOption">
            <app-editor-input-color
                name="fill"
                *ngIf="hasFillAttribute"
                (onIconClick)="deleteFill()"
                endIcon="minus"
                [value]="fillColor"
                (onInputChange)="handleFillChange($event)">
            </app-editor-input-color>
        </div>
    </div>
    <div class="option-container" *ngIf="!isStrokeHidden">
        <div class="title-container">
            <h6 class="sub-title contain-icon">
                {{ 'mimic-drawing.stroke' | translate }}
                <mat-icon
                    *ngIf="hasStrokeAttribute"
                    class="icon-pointer"
                    (click)="strokeIconClick()"
                    [svgIcon]="strokeHidden ? 'hidden' : 'visible'"></mat-icon>
            </h6>
            <mat-icon class="icon-pointer" *ngIf="!hasStrokeAttribute" (click)="addStroke()" svgIcon="plus"></mat-icon>
        </div>
        <div class="strok-input-container">
            <app-editor-input-color
                name="stroke"
                *ngIf="hasStrokeAttribute"
                (onIconClick)="deleteStroke()"
                endIcon="minus"
                [value]="strokeColor"
                (onInputChange)="handleStrokeChange($event)">
            </app-editor-input-color>
        </div>
        <app-stroke-mixed *ngIf="hasStrokeAttribute" [selectedElements]="selectedElements"> </app-stroke-mixed>
    </div>
</div>
